import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import SchedulesClient from '../components/SchedulesClient'
import { prefetchSchedules, prefetchPolicies, prefetchDevices } from '../lib/route-prefetch'

function SchedulesError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load schedules.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/schedules')({
  validateSearch: (search: Record<string, unknown>): { new?: boolean } => ({
    new: (search.new === true || search.new === 'true') ? true : undefined,
  }),
  head: () => ({
    meta: [{ title: 'Schedules | Unbreakable' }],
  }),
  beforeLoad: ({ context }) => {
    prefetchSchedules(context.queryClient)
    prefetchPolicies(context.queryClient)
    prefetchDevices(context.queryClient)
  },
  errorComponent: SchedulesError,
  component: SchedulesPage,
})

function SchedulesPage() {
  const { new: showNew } = Route.useSearch()
  return (
    <AuthGuard>
      <SchedulesClient showNewModal={showNew === true} />
    </AuthGuard>
  )
}
